<div *ngIf="isLoading" style="width: 50px">
  <mat-progress-bar mode="indeterminate" value="40"></mat-progress-bar>
</div>

<div *ngIf="!noSearchBar" class="search">
  <mat-form-field>
    <mat-icon matPrefix>search</mat-icon>
    <mat-label>{{ 'globals.search' | translate }}</mat-label>
    <input matInput (keyup)="applyFilter($event)" [placeholder]="translate.instant('globals.search') + '...'" />
  </mat-form-field>
</div>

<table mat-table matSort [dataSource]="dataSource">
  <ng-container *ngIf="!noSelection" matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>
      <mat-checkbox
        (change)="$event ? masterToggle() : null"
        [checked]="isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()"
        [aria-label]="checkboxLabel()"
        color="primary"
      >
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let row">
      <mat-checkbox
        (click)="$event.stopPropagation()"
        (change)="$event ? selection.toggle(row) : null"
        [checked]="selection.isSelected(row)"
        [aria-label]="checkboxLabel(row)"
        color="primary"
      >
      </mat-checkbox>
    </td>
  </ng-container>

  <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column.columnDef">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ column.header | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      <div class="overflow" [title]="element[column.tooltip ?? column.columnDef]">{{ element[column.columnDef] }}</div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns"></tr>

  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" [attr.colspan]="columns.length" style="text-align: center; padding: 20px;">
      {{ emptyMessage | translate }}
    </td>
  </tr>

  <ng-container *ngIf="!noActionMenu" matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef class="action-column"></th>
    <td mat-cell *matCellDef="let row" class="action-column">
      <div *ngIf="filteredActionMenuItems(row).length > 0">
        <button
          mat-icon-button
          [matMenuTriggerFor]="actionMenu"
          matTooltip="{{ 'globals.more' | translate }}"
          color="primary"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #actionMenu="matMenu">
          <ng-container *ngFor="let item of filteredActionMenuItems(row)">
            <button
              mat-menu-item
              (click)="$event.stopPropagation(); item.action(row)"
            >
              <mat-icon [color]="item.color">{{ item.icon }}</mat-icon>
              <span [class]="actionMenuItemTextColor(item.color)">{{ item.label | translate }}</span>
            </button>
          </ng-container>
        </mat-menu>
      </div>
    </td>
  </ng-container>
</table>

<mat-paginator
  *ngIf="!noPagination"
  [pageSizeOptions]="[10, 50, 100]"
  [pageSize]="10"
  showFirstLastButtons
>
</mat-paginator>
